import React from 'react';
import ProjectDetailView from 'components/ProjectDetailView/ProjectDetailView';
import pictureBuildingData from './data';

const PictureBuilding = () => {
  return <ProjectDetailView data={pictureBuildingData} />;
};

export default PictureBuilding;
